import { createContext } from 'react';

export const ViewportSizeContext = createContext({
  isSmall: false,
  isMedium: false,
  isLarge: false,
  isXL: false,
});
